import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTimeKeeperSystemType,
  updateProps,
} from '../../../contextRedux/TimeKeeperSystemType/TimeKeeperSystemTypeModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { TimeKeeperSystemTypeColumn } from './TimeKeeperSystemTypeColumn';

const TimeKeeperSystemTypeTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxTimeKeeperSystemType = useSelector((state: RootState) => state.models?.timeKeeperSystem);
  const timeKeeperSystemTypes = useSelector((state: RootState) => state.store?.timeKeeperSystem.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxTimeKeeperSystemType.props.skip / reduxTimeKeeperSystemType.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setTimeKeeperSystemType(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxTimeKeeperSystemType.props.take,
    total: reduxTimeKeeperSystemType.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxTimeKeeperSystemType.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={timeKeeperSystemTypes}
        pagination={paginationConfig}
        rowKey='id'
        className='table'
        columns={TimeKeeperSystemTypeColumn(handleEdit)}
      />
    </>
  );
};

export default TimeKeeperSystemTypeTable;
